function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  fill: "#d4ccbd",
  r: 4.5
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8.5,
  stroke: "#d4ccbd",
  strokeDasharray: "1 2",
  strokeLinecap: "round"
});
function SvgAltProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltProgress);
export default __webpack_public_path__ + "static/media/alt-progress.ecd5cc6fda0d062aee803af584eddf4e.svg";
export { ForwardRef as ReactComponent };